import React from 'react';
import Icon from '@pushpay/icon';

const BurgerMenuIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.87 4h18.26c.48 0 .87.377.87.842v.842c0 .465-.39.842-.87.842H2.87c-.48 0-.87-.377-.87-.842v-.842C2 4.377 2.39 4 2.87 4zm0 6.737h18.26c.48 0 .87.377.87.842v.842c0 .465-.39.842-.87.842H2.87c-.48 0-.87-.377-.87-.842v-.842c0-.465.39-.842.87-.842zm0 6.737h18.26c.48 0 .87.377.87.842v.842c0 .465-.39.842-.87.842H2.87c-.48 0-.87-.377-.87-.842v-.842c0-.465.39-.842.87-.842z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

export default BurgerMenuIcon;